import { Component, Input, Optional } from '@angular/core';
import { FlowComponent } from '../../../../flow/components/flow/flow.component';
import { OnBehalfFlowComponent } from "../../../../flow/components/on-behalf-flow/on-behalf-flow.component";
import { Question } from '../../../../flow/models/flow.model';

@Component({
    selector: 'form-control-label',
    templateUrl: './form-control-label.component.html',
    styleUrls: ['./form-control-label.component.scss'],
    standalone: false
})
export class FormControlLabelComponent {
    @Input()
    public question: Question;
    @Input()
    public flow: FlowComponent;
    @Input()
    public id: string;


    get requiresNotes(): boolean {
        if (this.question == null || this.question.config == null || this.question.config.requireNotes == null) return false;
        return this.question.config.requireNotes;
    }

    public addNote(event: MouseEvent): void {
        if (!this.flow)
            return;

        event.preventDefault();
        this.flow.addQuestionNote(this.question.contextTarget);
    }
}
